import { render, staticRenderFns } from "./SortedChat.vue?vue&type=template&id=1635f528&scoped=true&lang=pug&"
import script from "./SortedChat.vue?vue&type=script&lang=js&"
export * from "./SortedChat.vue?vue&type=script&lang=js&"
import style0 from "./SortedChat.vue?vue&type=style&index=0&id=1635f528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635f528",
  null
  
)

export default component.exports